import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

import CookiesHelper from 'src/common/helpers/CookieHelpers';
import { clearLocalStorageExcept } from 'src/common/helpers/localstorage-utils';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { useLocalStorage } from 'src/hooks/useLocalStorage';
import { APP_URLS } from 'src/setup/client/app-urls';
import { fetchUserBaseInfo, refreshAuthToken } from 'src/setup/redux/slices/userSlice';

interface AuthContextValue {
    userId: string | null;
    isAuthenticated: boolean;
    setAuthenticated: () => void;
    setUnauthenticated: () => void;
    showWelcomeModal: boolean;
    // eslint-disable-next-line no-unused-vars
    setShowWelcomeModal: (value: boolean) => void;
}

// @ts-ignore
const AuthContext = createContext();

export const AuthProvider = ({ children }: any) => {
    const dispatch = useAppDispatch();
    const { isTokenReady } = useAppSelector((state) => state.user);
    const [showWelcomeModal, setShowWelcomeModal] = useLocalStorage('showWelcomeModal', null);
    const [userId, setUserId] = useState(CookiesHelper.read('user_id'));

    const setAuthenticated = async () => {
        localStorage.removeItem('favorite');
        localStorage.setItem('showNotificationPopup', 'false');

        const user_id = CookiesHelper.read('user_id');
        user_id && setUserId(user_id);

        setShowWelcomeModal(true);
        dispatch(fetchUserBaseInfo());

        window.location.href = APP_URLS.HOME;
    };

    const setUnauthenticated = () => {
        clearLocalStorageExcept(['isSimplifiedTradeActive']);
        setUserId(null);
        setShowWelcomeModal(false);
        CookiesHelper.clearAll();
        window.location.href = APP_URLS.LOGIN;
    };

    useEffect(() => {
        if (userId) {
            dispatch(refreshAuthToken());
        }
    }, [userId]);

    const value = useMemo(
        () => ({
            userId,
            isAuthenticated: !!userId && isTokenReady,
            setAuthenticated,
            setUnauthenticated,
            showWelcomeModal: showWelcomeModal && !!userId && isTokenReady,
            setShowWelcomeModal,
        }),
        [userId, showWelcomeModal, isTokenReady],
    );

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
    return useContext(AuthContext) as AuthContextValue;
};
